import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import MajorCourseEditModal from '../MajorCourseEditModal/MajorCourseEditModal';
import './MajorCourseTable.css';

export default function MajorCourseTable({ majorCourses, getMajorCourse }) {
  const [showMajorCourseEditModal, setShowMajorCourseEditModal] = useState(false);
  const [majorCourseChange, setMajorCourseChange] = useState();

  function handleMajorCourseEditmModalShow(majorCourse) {
    setMajorCourseChange(majorCourse);
    setShowMajorCourseEditModal(true);
  }

    return (
      <>
        <MajorCourseEditModal
          getMajorCourse={getMajorCourse}
          majorCourseChange={majorCourseChange}
          showMajorCourseEditModal={showMajorCourseEditModal}
          setShowMajorCourseEditModal={setShowMajorCourseEditModal}
        />
        <Table striped hover>
          <thead className='bgvi'>
            <tr>
              <th>#</th>
              <th>ชื่อหลักสูตร</th>
              <th>รหัสหลักสูตร</th>
              <th>เปิดใช้งาน</th>
              <th>ผ่านหน่วย หน.สายวิทยาการ</th>
              <th>คำอธิบาย</th>
            </tr>
          </thead>
            <tbody>
              {majorCourses.map((majorCourse, index) => (
                <tr key={index} 
                  onClick={() => {handleMajorCourseEditmModalShow(majorCourse)}
                }>
                  <td> {index + 1} </td>
                  <td>{majorCourse.name}</td>
                  <td>{majorCourse.pme_no}</td>
                  <td>{majorCourse.is_active ? 'เปิด' : 'ปิด'}</td>
                  <td>{majorCourse.is_spc_approve ? 'ใช่' : 'ไม่ใช่'}</td>
                  <td>{majorCourse.description}</td>
                </tr>
              ))}
            </tbody>
        </Table>
      </>
    );
}